import { EnergyRating } from "@JohnLewisPartnership/jl-design-system/dist/components/energy-rating/EnergyRating";
import styles from "./EnergyLabelCTA.module.scss";
import { ArrowRightOutlined as ArrowRight } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/ArrowRightOutlined";
import { ChevronRightOutlined as ChevronRight } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/ChevronRightOutlined";
import { SecondaryButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import { ListItem } from "../../../__shared__/ListItem/ListItem";
import classnames from "classnames/bind";

const cx = classnames.bind(styles);

export type EnergyLabelCTAProps = {
  handleClick?: () => void;
  isLegacy: boolean;
  rating: string;
  dataComponent?: string;
  enableNewEnergyAndYourekoLabels: boolean;
};

export const EnergyLabelCTA = ({
  handleClick,
  isLegacy,
  rating,
  dataComponent,
  enableNewEnergyAndYourekoLabels,
}: EnergyLabelCTAProps) => {
  if (enableNewEnergyAndYourekoLabels) {
    return (
      <SecondaryButton
        className={cx("energyLabelItem", "premiumStyle")}
        size="medium"
        onClick={handleClick}
      >
        <EnergyRating
          rating={isLegacy ? undefined : rating}
          ratingLegacy={isLegacy ? rating : undefined}
          className={styles.energyLabelIcon}
        />
        <span className={cx("energyRatingText")}>Energy rating</span>
        <ChevronRight size="medium" />
      </SecondaryButton>
    );
  }

  return (
    <ListItem
      leadingIcon={
        <EnergyRating
          rating={isLegacy ? undefined : rating}
          ratingLegacy={isLegacy ? rating : undefined}
          className={styles.energyLabelIcon}
        />
      }
      trailingIcon={
        handleClick ? (
          <ArrowRight dataTestId={"energy-rating-arrow"} size="medium" />
        ) : undefined
      }
      label={
        <>
          Energy rating: <span className={styles.rating}>{rating}</span>
        </>
      }
      onClick={handleClick}
      className={styles.energyLabelItem}
      dataComponent={dataComponent}
    />
  );
};
